export const WIZARD_VERSION_2_2 = 22 // 2.2
export const WIZARD_VERSION_3_0 = 30 // 3.0
export const WIZARD_VERSION_3_4 = 34 // 3.0

export const WIZARD_CURRENT_VERSION = WIZARD_VERSION_3_4
